/* Routes for the notifications page (Area C: account). Paths are relative; see src/app/routes.ts. */
import { page, type AreaRoutes } from '@/app/routes'

export const routes: AreaRoutes = {
  shell: [{ path: 'notifications', lazy: page(() => import('./pages/NotificationsPage')) }],
}
